/* eslint-disable */
import React, { Component } from 'react';
import cIf from 'classnames';

import { InSaleStatus } from '../../../types/models';
import { PackageInfoModel } from '../../../mvcapi/models/common/package-info-model';

var tr = require('ts-translate-js').default.boundTR;

var getMomentTZDateTime = require('ts-util').getMomentTZDateTime;


export type SaleMessagesInfoProps = {
    packageInfo: PackageInfoModel,
};

export class SaleMessagesInfo extends Component<SaleMessagesInfoProps> {
    constructor(props) {
        super(props);
    }

    render() {

        var message = [];


        if(this.props.packageInfo.InSaleStatus === InSaleStatus.SALENOTSTARTEDYET) {
            message.push(
                <div key="label" className="col-xs-12 text-justify">
                    <label>{tr("Mise en vente") + tr(":")}</label>
                </div>);


            message.push(
                <div key="public" className="col-xs-12 text-justify">
                    <div className="col-xs-4 col-sm-4 text-right text-bold text-uppercase nowrap">{tsapp.tr("program.salesinfo.public")}</div>
                    <div className="col-xs-8 col-sm-8 text-left nowrap">{getMomentTZDateTime(this.props.packageInfo.SalesStartDate, this.props.packageInfo.TimeZone.TZDatabaseID).format(tsapp.tr("program.format.moment.datetime"))}</div>
                </div>); // la date est déjà en local date
        }
        else if(this.props.packageInfo.IsPackageSoldOut)
        {
            message.push(<div key="soldout" className="col-xs-12">{tsapp.tr("Le nombre de forfait a été épuisés")}</div>); // Coder mais nous n'avons encore aucune place pour setter le soldout d'un package
        }
        else if(this.props.packageInfo.InSaleStatus === InSaleStatus.SALENOTEND || this.props.packageInfo.InSaleStatus === InSaleStatus.SALEFINISH)
        {
            message.push(<div key="notinsale" className="col-xs-12">{tsapp.tr("Le forfait n'est plus en vente présentement")}</div>);
        }
        else
        {
            message.push(<div key="errorselling" className="col-xs-12">{this.props.packageInfo.ErrorSellingThisPackageMessage}</div>);
        }



        return (
            <div className={cIf("alert text-center", {"alert-warning": this.props.packageInfo.InSaleStatus === InSaleStatus.SALENOTSTARTEDYET,
                                                        "alert-danger": this.props.packageInfo.InSaleStatus !== InSaleStatus.SALENOTSTARTEDYET})}>
                <div className="row">
                    {message}
                </div>
            </div>
        );
    }
};
